import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "./App.tsx"
import "./style/theme.scss"
import "./style/atlante.scss"
import '@inmagik/magik-ui/style.css'

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://3ecafc2881a229b4727fd1055b4cb151@o1047151.ingest.us.sentry.io/4508483065479168",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
